import { useEffect } from 'react';

import { useRouter } from 'next/navigation';

function usePrintRedirect() {
  const router = useRouter();

  useEffect(() => {
    const handleBeforePrint = () => {
      if (!window.location.pathname.endsWith('print')) {
        window.location.href = `${window.location.pathname}/print`;
        return;
      }
    };

    window.addEventListener('beforeprint', handleBeforePrint, true);

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint);
    };
  }, [router]);
}

export { usePrintRedirect };
